import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Heading: () => <>Travel</>,
        SubHeading: () => (
            <>
                Our wedding will be in <strong>Chiang Mai, Thailand</strong>.
                Here's info on how to get
                there, where to stay, and how to get around.
            </>
        ),
    },
    [LANGUAGE.ZH]: {
        Heading: () => <>出发吧！</>,
        SubHeading: () => (
            <>
                我们的婚礼将在泰国清迈举行。下面是一些可能有帮助的信息。
            </>
        ),
    },
}
